
export default {
  name: 'TheMainFooter',
  data: () => ({
    external_links: [
      {
        name: 'homepage',
        to: 'https://www.cre.ma/'
      },
      {
        name: 'facebook',
        to: 'https://www.facebook.com/review.target.fit/'
      },
      {
        name: 'kakao',
        to: 'https://pf.kakao.com/_qxmKKK/'
      },
      {
        name: 'naverblog',
        to: 'https://blog.naver.com/cremablog/'
      },
      {
        name: 'brunch',
        to: 'https://brunch.co.kr/@cremasolution/'
      },
      {
        name: 'youtube',
        to:
          'https://www.youtube.com/channel/UCX5aliKKHduL-p8dMw1J2ZQ/featured?view_as=subscriber/'
      }
    ]
  })
};
